import { render, staticRenderFns } from "./TerminalTable.vue?vue&type=template&id=706c04e6"
import script from "./TerminalTable.vue?vue&type=script&lang=js"
export * from "./TerminalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports